import React, { useState, useEffect } from "react";
import { Button } from "../../../components/Component";
const DGEDashboardCount = ({ ...props }) => {
    const [Count, setCount] = useState(0);
    const [Lorder, setLorder] = useState(true);
    const [isShown, setIsShown] = useState(false);
    const changepage = async (id) => {
        const sendData = {
            CatgTypeId: Number(id),

        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*//console.log(data)*/
                    localStorage.setItem('userId', data.userId)
                    window.location.pathname ="/Dashboard"
                    /*props.history.push("/Dashboard")*/
                    setLorder(false)
                })


    };



    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            MonthId: Number(props.month),
            Month: String(props.catgtype),
        }
        /*//console.log(sendData)*/
        
        await fetch(process.env.REACT_APP_API_LINK +'api/Payment/'+props.api, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*//console.log(data)*/
                    setCount(data)
                    setLorder(false)
                })


    };

    useEffect(() => {
        setLorder(true)
        getdata()
    }, [])


    return (
        <>
                <td> <b style={{ fontSize: 18 }}>{Count.eex}</b></td>
                <td> <b style={{ fontSize: 18 }}>{Count.total}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.open}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.edit}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.submit}</b></td> 
             
            </>
    )  
};

export default DGEDashboardCount;
